import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-the-header-navi-of-category-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTile = _resolveComponent("IconTile")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_CategoryNaviItemLink = _resolveComponent("CategoryNaviItemLink")!
  const _component_InlineSvg = _resolveComponent("InlineSvg")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.naviItem, ({ label, url, children, ref }, key) => {
      return (_openBlock(), _createElementBlock("li", { key: key }, [
        _withDirectives((_openBlock(), _createBlock(_component_CategoryNaviItemLink, {
          tag: "a",
          "params-object": _ctx.parentItemObj(children),
          "is-child-item": false,
          href: url,
          onEmitChildItemObject: _ctx.emitChildItemObject
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_IconBase, {
              width: 24,
              height: 24,
              "view-box": "0 0 24 24"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconTile)
              ]),
              _: 1
            })
          ]),
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(label), 1)
          ]),
          _: 2
        }, 1032, ["params-object", "href", "onEmitChildItemObject"])), [
          [_directive_touch, void 0, "tap"]
        ]),
        children
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              ref_for: true,
              ref: ref,
              class: "p-the-header-navi-on-general__navi p-the-header-navi-on-general__navi--child"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, ({ name, sub_categories, icon }, childKey) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: childKey,
                  class: "p-the-header-navi-on-general__navi__item"
                }, [
                  _createVNode(_component_CategoryNaviItemLink, {
                    tag: "button",
                    "params-object": _ctx.childItemObj(childKey, sub_categories, name),
                    onEmitChildItemObject: _ctx.emitChildItemObject
                  }, {
                    icon: _withCtx(() => [
                      icon
                        ? (_openBlock(), _createBlock(_component_InlineSvg, {
                            key: 0,
                            src: icon,
                            width: "20",
                            height: "20",
                            fill: _ctx.iconColor,
                            "aria-label": name
                          }, null, 8, ["src", "fill", "aria-label"]))
                        : _createCommentVNode("", true)
                    ]),
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(name), 1)
                    ]),
                    _: 2
                  }, 1032, ["params-object", "onEmitChildItemObject"]),
                  sub_categories
                    ? (_openBlock(), _createElementBlock("ul", {
                        key: 0,
                        ref_for: true,
                        ref: "grandchildNavi",
                        class: "p-the-header-navi-on-general__navi p-the-header-navi-on-general__navi--child p-the-header-navi-on-general__navi--grandchild"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sub_categories, ({ name, id }, grandchildKey) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: grandchildKey,
                            class: "p-the-header-navi-on-general__navi__item"
                          }, [
                            _withDirectives((_openBlock(), _createBlock(_component_CategoryNaviItemLink, {
                              tag: "a",
                              "params-object": _ctx.grandChildItemObj(grandchildKey),
                              href: '/product-list/?product-category=' + id,
                              onEmitChildItemObject: _ctx.emitChildItemObject
                            }, {
                              label: _withCtx(() => [
                                _createTextVNode(_toDisplayString(name), 1)
                              ]),
                              _: 2
                            }, 1032, ["params-object", "href", "onEmitChildItemObject"])), [
                              [_directive_touch, void 0, "tap"]
                            ])
                          ]))
                        }), 128))
                      ], 512))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 512))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}